import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import {map, catchError} from 'rxjs/operators';
import { ApiEndPoints, AccountsApiEndPoints } from './../../app.config';
import { HttpService } from './../../shared/http/http.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class UserService {
  private url: string = AccountsApiEndPoints.apiEndpoint;
  private app_url: string = ApiEndPoints.apiEndpoint;
  private baseurl :any = environment.apiURL

  constructor(private http: HttpService) { }

  login(email: any, password: any) {
    return this.http.post(this.url + 'salesrep-signin/', { email: email, password: password })
    .pipe(
      map((response: Response) => {
        return this.extractData(response, response.status);
      }),
      catchError(this.handleError)
    );
  }

  logout() {
    return this.http.put(this.url + 'signout/', {});
  }

  changePassword(old_password: any, new_password: any) {
    return this.http.put(this.url + 'changepassword/', { old_password: old_password, new_password: new_password })
      .map(this.extractData)
      .catch(this.handleError);
  }

  createHashedPassword(password:string):string { 
    let CryptoJS = require("crypto-js");

    let key = CryptoJS.enc.Utf8.parse(environment.hashedSecretKey);

    let iv = CryptoJS.enc.Utf8.parse(environment.hashedIV);

    const ciphertext = CryptoJS.AES.encrypt(password, key, {
      iv: iv,
      mode: CryptoJS.mode.CTR,
      padding:CryptoJS.pad.Pkcs7
    }).toString(); 
    return ciphertext;
  }

  forgotPassword(email: any) {
    return this.http.post(this.url + 'salesrep-forgotpassword/', { email: email })
      .pipe(
        map((response: Response) => {
          return this.extractData(response, response.status);
        }),
        catchError(this.handleError)
      );
  }

  resetPassword(password: any, confirm_password: any, token: any) {
    return this.http.put(this.url + 'resetpassword/', { password: password, confirm_password: confirm_password, token: token })
      .map(this.extractData)
      .catch(this.handleError);
  }

  verifyEmail(token: any) {
    return this.http.put(this.url + 'verifyemail/', { token: token })
      .map(this.extractData)
      .catch(this.handleError);
  }

  // Extract/Handle Data from response
  private extractData(res, status) {
    if (res.ok && res.status === 200) {
      const body = res.json();
      return body || {};
    } else {
      return Observable.throw('Error in api\'s (server)');
    }
  }

  // Handle Errors
  private handleError(error: HttpErrorResponse) {
    if (error['_body']){
      return throwError(error['_body']);
    }
    return throwError(error);
  }
}
